<template>
  <a-card title="任务模板配置" >
    <a-tabs v-model:activeKey="formSearch.region_code" @change="handleTableChange()" >
      <a-tab-pane key="" tab="全部"></a-tab-pane>
      <a-tab-pane key="CN" tab="中国 CN"></a-tab-pane>
      <a-tab-pane key="US" tab="美国 US"></a-tab-pane>
    </a-tabs> 
    <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
      <a-form-item label="模板ID">
        <a-input placeholder="Template ID" v-model:value="formSearch.template_id" />
      </a-form-item>
      <a-form-item label="TabID">
        <a-input placeholder="TabID" v-model:value="formSearch.tab_id" />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="标题" v-model:value="formSearch.title" />
      </a-form-item>
      <a-form-item  label="工具 ID">
        <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formSearch.tool_id"
          :options="ToolIDOptions"
          placeholder="工具 ID"
        />
      </a-form-item>
      <a-form-item  label="上线状态">
        <a-select
          :allowClear="true"
          v-model:value="formSearch.status"
          :options="[
            { value: 1, label: '上线' },
            { value: 0, label: '下线' }
          ]"
          placeholder="上线状态"
        />
      </a-form-item>
      <a-form-item  label="任务类型">
        <a-select
          :allowClear="true"
          style="width: 230px;"
          v-model:value="formSearch.style_id"
          :options="TaskStyleGroupOptions"
          placeholder="任务类型 ID"
        />
      </a-form-item>
      <a-form-item   label="任务子类型"  name="sub_type">
        <a-select
          :allowClear="true"
        style="width:100px;"
          v-model:value="formSearch.sub_type"
          :options="SubTypeOptions"
          placeholder="SubType"
        />
      </a-form-item>
     
      <a-form-item  label="性别" name="gender" >
        <a-select
        :allowClear="true"
        style="width:100px;"
          v-model:value="formSearch.gender"
          :options="[
            { value: 'male', label: '男' },
            { value: 'female', label: '女' }
          ]"
          placeholder="性别"
        />
      </a-form-item>
      <a-form-item label="地区">
         <a-select
            :allowClear="true"
            style="width: 100px"
            v-model:value="formSearch.region_code"
            :options="NationCodes"
            placeholder="国家地区"
          />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="操作人ID" v-model:value="formSearch.operator_id" />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          @click="handleTableChange()"
          shape="circle"
        >
        <template #icon><SearchOutlined /></template>
        </a-button>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          @click="handleCreate"
        >
        新建
        </a-button>
        <a-button
          type="primary"
          style="margin-left: 10px;"
          @click="handleBatchCreate"
        >
        批量创建
        </a-button>
      </a-form-item>
    </a-form>
    

    <a-alert   v-if="formSearch.tab_id == 165"  :message="'165 是AI修图的专用测试 Tab'" type="warning" show-icon style="text-align: left;"  />
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
    <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
      <template #style_name="{ record }">
        <div style="width:160px;">
          类型: {{ StyleFlowNames[record.style_id]}} 
          <br />
          子类型: {{ subTypeNames[record.sub_type]}} 
        </div>
      </template>
      <template #tool_id="{ record }">
        <div style="width:100px;">
         {{ record.tool_id ? ToolNames[record.tool_id] : '-'}} 
        </div>
      </template>
      <template #tab_name="{ record }">
       <a :href="'/home/creation/tabs?id=' + record.tab_id" target="_blank">{{ record.tab_name }}</a>
      </template>
      <template #image_url="{ record }">
        <a-image
          style="width: 100px;"
          placehoder="true"
          :src="record.image_url" width="100"
        />
        <div v-if="record.tool_id === 'image2video'" style="margin-top: 6px;">
          <div style="font-size: 12px; color: #999;">mask</div>
          <a-image
            style="width: 100px;"
            placehoder="true"
            :src="record.mask_url" width="100"
          />
        </div>
      </template>
      <template #sort="{ record }">
        <a-input-group compact  style="width: 150px;">
          <a-input v-model:value="record.sorted"  style="width: 80px;" />
          <a-button type="primary" @click="handleModifySort(record)"  >设置</a-button>
        </a-input-group>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status == 1" color="green">已上线</a-tag>
        <a-tag v-if="record.status == 0" color="gray">已下线</a-tag>
        <a-tag v-if="record.status == 2" color="yellow">预览中</a-tag>
      </template>
      <template #is_delete="{ record }">
        <a-tag v-if="record.is_delete == 1" color="gray">已删除</a-tag>
        <a-tag v-if="record.status == 0" color="green">正常</a-tag>
      </template>
      <template #region_code="{ record }">
        <div v-if="record.region_code != 'CN'" style="width:30px; text-align:center; padding:2px; border-radius:4px; background: linear-gradient(120.86deg, rgb(63 9 157) 0%, rgb(105 39 219) 100%); color: #FFF;">
          {{ record.region_code }} 
        </div>
        <div v-else >
          {{ record.region_code }} 
        </div>
      </template>

      <template #opeartor="{ record }">
        <a target="_blank" :href="`/home/user?user_id=${record.operator_id}`">{{Operators[record.operator_id] ? Operators[record.operator_id] : record.operator_id}}</a>
      </template>

      <template #created_at="{ record }">
       <div>创建时间: {{ record.created_at.toLocaleString() }}</div>
       <div>修改时间: {{ record.updated_at.toLocaleString() }}</div>
      </template>
      <template #action="{ record }">
       <a-space>
        
        <a-popconfirm
          title="确定下线吗?"
          ok-text="确定"
          cancel-text="不了"
          @confirm="handleModifyStatus(record, '0')"
        >
          <a-button v-if="record.status == 1"  danger >下线</a-button>
         
        </a-popconfirm>
        <a-button  @click="handleModifyStatus(record, '1')" v-if="record.status == 0" type="primary">上线</a-button>
        <!-- <a-button @click="handleModifyStatus(record, '2')"  v-if="record.status == 0"  warning >测试环境预览</a-button> -->
        <a-button  warn @click="() => { handleCopy(record) }"  >复制</a-button>
        <a-button  warn @click="() => { handleUpdate(record) }"  >编辑</a-button>
        <!-- <a-button v-if="record.is_delete == 1" type="primary" @click="() => { handleOnline(record) }"  >上线</a-button> -->

        <a-popconfirm
          title="确定删除吗?"
          ok-text="确定"
          cancel-text="不了"
          @confirm="handleDelete(record)"
        >
          <a-button v-if="record.is_delete == 0 && record.status == 0" danger   >🗑️ 删除</a-button>
        </a-popconfirm>
       </a-space>
      </template>
      </a-table>
  </a-card>
  <a-modal width="80%" v-model:visible="openDia" 
  :title="formRecord.id == 0 ? formRecord.is_copy ? '复制并创建模板': '创建新模板' : '修改模板'" 
  @cancel="resetForm" :ok-text="formRecord.id == 0 ? formRecord.is_copy ? '确认复制': '确认创建' : '确认修改'" 
  @ok="handleConfirm" 
  :confirm-loading="loading"
  destroy-on-close
  
  >
    <a-form :label-col="{ span: 6 }" :model="formRecord"   style="margin: 10px auto;" :rules="rules" ref="formRef" >
      <div style="display: flex;flex-direction: row; justify-content: center;">
        <div style="width: 400px;margin: 10px;">
          <p class="form-section-title">基本信息</p>
          <a-form-item required label="后台名称" name="title">
            <a-input placeholder="用户不可见，可与标题中文一致" v-model:value="formRecord.title" />
          </a-form-item>
            <a-form-item required label="工具">
              <a-select
              :allowClear="true"
                style="width: 100px;"
                v-model:value="formRecord.tool_id"
                :options="ToolIDOptions"
                placeholder="工具"
              />
            </a-form-item>
          <a-form-item required label="国家地区" name="region_code">
            <a-input-group compact style="width: 300px; display: flex;">
              <a-select
                style="width: 120px"
                v-model:value="formRecord.region_code"
                :options="NationCodes"
                placeholder="国家地区"
              />
              <a-input style="width: 80px" placeholder="国家地区" v-model:value="formRecord.region_code" />
              
            </a-input-group>
            <p>*需要展示模版的国家地区 </p>
          </a-form-item>
           
          <a-form-item required label="所属 Tab" name="tab_id">
            <a-space>
              <a-select
                v-if="optionTabs.length > 0 || formRecord.tab_id"
                style="width: 160px;"
                v-model:value="formRecord.tab_id"
                :options="optionTabs"
                placeholder="Tab 名称"
              />
              <a-button @click="getOptionTabs" type="primary" >加载 Tab</a-button>
              <a-button
                type="primary"
                @click="searchOptionTabs"
                shape="circle"
              >
                <template #icon><SearchOutlined /></template>
              </a-button>
            </a-space>
            <!-- <Inputi18n path_prefix="任务-模板Tab" v-model:valid="formRecord.tab_name_i18n_valid"  v-model:value="formRecord.tab_name" /> -->
          </a-form-item>
          <a-form-item required label="排序" name="sorted">
            <a-input placeholder="sorted" v-model:value="formRecord.sorted" />
            <p>*数字越大越靠前 </p>
          </a-form-item>
          <p class="form-section-title">展示信息</p>
          <a-form-item required label="标题(国际化)" name="name">
              <Inputi18nInline  v-model:valid="formRecord.name_i18n_valid" v-model:value="formRecord.name" />
          </a-form-item>
          <a-form-item  label="*封面(效果图)" name="image_url">
            <a-tabs v-model:activeKey="formRecord.cover_media_type">
              <a-tab-pane key="image" tab="图片">
                <Upload v-model:imageUrl="formRecord.image_url"  />
                <a-input disabled placeholder="refer_url" v-model:value="formRecord.image_url" />
              </a-tab-pane>
              <a-tab-pane key="video" tab="视频">
                <ConvertVideo v-model:videoURL="formRecord.video_url" v-model:webpURL="formRecord.image_url"  />
                <a-input disabled placeholder="video_url (原视频)" v-model:value="formRecord.video_url" />
                <a-input disabled placeholder="webp_url (封面)" v-model:value="formRecord.image_url" />
              </a-tab-pane>
            </a-tabs>
          </a-form-item>
          <a-form-item label="封面(原图)" name="cover_blind">
            <Upload v-model:imageUrl="formRecord.cover_blind"  />
            <a-input disabled placeholder="cover_blind" v-model:value="formRecord.cover_blind" />
          </a-form-item>
          <a-form-item label="模板动画位置" name="blind_position">
            <a-select
                v-model:value="formRecord.blind_position"
                :options="[{
                  label: '编辑器',
                  value: 'editor',
                },{
                  label: '首页',
                  value: 'home',
                },{
                  label: '所有页面',
                  value: 'all',
                }]"
                placeholder="动画展示位置"
              />
          </a-form-item>
          <a-form-item label="推荐标签" name="label">
              <Inputi18nInline  v-model:valid="formRecord.label_i18n_valid" v-model:value="formRecord.label" />
          </a-form-item>
         
        </div>
        <div style="margin: 10px;width: 400px;">
           <p class="form-section-title">生成参数</p>
          <a-form-item  label="跳转地址"  name="redirect_url">
            <a-input placeholder="redirect_url" v-model:value="formRecord.redirect_url" />
            <a-alert message="如有则「忽略」下面的参数" type="warning" show-icon  />
          </a-form-item>

          <a-form-item required label="任务流类型"  name="style_id">
            <a-select
              v-model:value="formRecord.style_id"
              :options="TaskStyleGroupOptions"
              placeholder="StyleID"
            />
            <!-- <a-alert message="老版本编辑器根据「任务流类型」进行聚合输出模板列表" type="warning" show-icon="true"></a-alert> -->
          </a-form-item>
          <template v-if="formRecord.style_id === 'pixverse-img2video'">
            <a-form-item label="模板ID" name="img2video_template_id">
              <a-input-number :min="0" :controls="false" style="width: 200px;" placeholder="填写爱诗的模板ID" v-model:value="formRecord.img2video_template_id" />
            </a-form-item>
            <a-form-item label="是否需要声音" name="need_audio">
              <a-radio-group v-model:value="formRecord.need_audio">
                <a-radio :value="true">是</a-radio>
                <a-radio :value="false">否</a-radio>
              </a-radio-group>
              <p style="color: #ff4d4f; font-size: 12px; margin-top: 4px;">请确认模板是否支持声音，务必测试完再上线</p>
            </a-form-item>
          </template>
          <a-form-item label="积分是否展示" name="show_scores">
            <a-radio-group v-model:value="formRecord.show_scores">
              <a-radio :value="true">展示</a-radio>
              <a-radio :value="false">不展示</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="积分消耗" name="scores">
            <a-input-number :min="0" style="width: 100px;" v-model:value="formRecord.scores" />
            <p style="color: #ff4d4f; font-size: 12px; margin-top: 4px;">如果积分为0，以工具积分为准</p>
          </a-form-item>
          <a-form-item  label="任务子类型"  name="sub_type">
            <a-select
              v-model:value="formRecord.sub_type"
              :options="SubTypeOptions"
              placeholder="SubType"
            />
          </a-form-item>
          <a-form-item label="涂抹" name="spreadable">
            <a-select
                style="width: 80px;"
                v-model:value="formRecord.spreadable"
                :options="spreadableOptions"
                placeholder="spreadable"
              />
          </a-form-item>
          <template v-if="formRecord.spreadable !== '0'">
            <a-form-item label="笔刷默认值" name="brush_size">
              <a-input-number :min="1" style="width: 100px;" v-model:value="formRecord.brush_size" placeholder="brush_size" />
            </a-form-item>
            <a-form-item label="笔刷最大值" name="brush_max_size">
              <a-input-number :min="1" style="width: 100px;" v-model:value="formRecord.brush_max_size" placeholder="brush_max_size" />
            </a-form-item>
            <a-form-item label="笔刷最小值" name="brush_min_size">
              <a-input-number :min="1" style="width: 100px;" v-model:value="formRecord.brush_min_size" placeholder="brush_min_size" />
            </a-form-item>
            <a-form-item label="笔刷类型" name="brush_type">
              <a-select
                  style="width: 120px;"
                  v-model:value="formRecord.brush_type"
                  :options="[
                    { value: 'Normal', label: 'Normal' },
                    { value: 'EndTaper', label: 'EndTaper' },
                    { value: 'BothTaper', label: 'BothTaper' }
                  ]"
                  placeholder="brush_type"
                />
            </a-form-item>
          </template>
          <a-form-item label="默认提示词" name="prompt">
            <a-textarea :rows="3" placeholder="prompt" v-model:value="formRecord.prompt" />
          </a-form-item>
          <template v-if="formRecord.ori_url" >
            <a-form-item v-if="formRecord.ori_url && formRecord.ori_url.indexOf('.mp4') > 0 " required label="参考视频" name="ori_url">
              <UploadVideo v-model:videoURL="formRecord.ori_url"  />
              <a-input disabled placeholder="refer_url" v-model:value="formRecord.ori_url" />
            </a-form-item>
            <a-form-item v-else label="参考图" name="ori_url">
              <Upload v-model:imageUrl="formRecord.ori_url"  />
              <a-input disabled placeholder="ori_url" v-model:value="formRecord.ori_url" />
            </a-form-item>
          </template>
          <template v-else >
            <a-form-item label="参考视频" name="ori_url">
              <UploadVideo v-model:videoURL="formRecord.ori_url"  />
            </a-form-item>
            <a-form-item  label="参考图" name="ori_url">
              <Upload v-model:imageUrl="formRecord.ori_url"  />
              <a-button style="margin:4px;" type="primary" size="small" @click="formRecord.ori_url = formRecord.image_url">使用封面</a-button>

            </a-form-item>
          </template>
          <a-form-item v-if="formRecord.tool_id === 'image2video'" label="mask图" name="mask_url">
            <Upload v-model:imageUrl="formRecord.mask_url" />
            <a-input disabled placeholder="mask_url" v-model:value="formRecord.mask_url" />
          </a-form-item>
        
        
          <a-form-item label="性别" name="typeid">
            <a-select
                style="width: 80px;"
                v-model:value="formRecord.typeid"
                :options="[
                  {
                    value: '',
                    label: '所有'
                  },
                  {
                    value: 'female',
                    label: '女性'
                  },
                  {
                    value: 'male',
                    label: '男性'
                  },
                ]"
                placeholder="typeid"
              />
          </a-form-item>
          <template v-if="formRecord.tool_id == 'clothes'">
            <a-form-item label="分类名称" name="category_name">
              <a-select
                  style="width: 100px;"
                  v-model:value="formRecord.category_name"
                  :options="categoryOptions"
                  placeholder="category_name"
                />
              <!-- <a-input placeholder="category_name" v-model:value="formRecord.category_name" /> -->
              <p>*仅换装需要填写</p>
            </a-form-item>
          </template>
        
          <a-form-item label="Position" name="position">
            <a-input placeholder="position" v-model:value="formRecord.position" />
          </a-form-item>
          <a-form-item label="扩展参数" name="value">
            <a-textarea placeholder="extend params" v-model:value="formRecord.value" />
          </a-form-item>
        </div>
      </div>

      <a-alert v-if="formRecord.name_i18n_valid"  type="success" message="支持 i18n" banner />
      <a-alert v-else  type="error" message="未生成 i18n 文案" banner />
      </a-form>
  </a-modal>

  <!-- 批量创建弹窗 -->
  <a-modal width="90%" v-model:visible="openBatchDia" 
  :title="'批量创建模板'" 
  @cancel="resetBatchForm" :ok-text="'确认创建'" 
  @ok="handleBatchConfirm" 
  :confirm-loading="loading"
  destroy-on-close
  
  >
    <a-form :label-col="{ span: 4 }" :model="batchCommonParams" style="margin: 10px auto;" >
      <div style="display: flex;flex-direction: column; align-items: center;">
        <!-- 通用参数 -->
        <div style="width: 800px;margin: 10px;">
          <p class="form-section-title">通用参数</p>
          <a-form-item required label="工具">
            <a-select
            :allowClear="true"
              style="width: 100px;"
              v-model:value="batchCommonParams.tool_id"
              :options="ToolIDOptions"
              placeholder="工具"
            />
          </a-form-item>
          <a-form-item required label="国家地区" name="region_code">
            <a-input-group compact style="width: 300px; display: flex;">
              <a-select
                style="width: 120px"
                v-model:value="batchCommonParams.region_code"
                :options="NationCodes"
                placeholder="国家地区"
              />
              <a-input style="width: 80px" placeholder="国家地区" v-model:value="batchCommonParams.region_code" />
              
            </a-input-group>
            <p>*需要展示模版的国家地区 </p>
          </a-form-item>
           
          <a-form-item required label="所属 Tab" name="tab_id">
            <a-space>
              <a-select
                v-if="optionTabs.length > 0 || batchCommonParams.tab_id"
                style="width: 160px;"
                v-model:value="batchCommonParams.tab_id"
                :options="optionTabs"
                placeholder="Tab 名称"
              />
              <a-button @click="getBatchOptionTabs" type="primary" >加载 Tab</a-button>
              <a-button
                type="primary"
                @click="searchBatchOptionTabs"
                shape="circle"
              >
                <template #icon><SearchOutlined /></template>
              </a-button>
            </a-space>
          </a-form-item>
          
          <p class="form-section-title">生成参数</p>
          <a-form-item  label="跳转地址"  name="redirect_url">
            <a-input placeholder="redirect_url" v-model:value="batchCommonParams.redirect_url" />
            <a-alert message="如有则「忽略」下面的参数" type="warning" show-icon  />
          </a-form-item>

          <a-form-item required label="任务流类型"  name="style_id">
            <a-select
              v-model:value="batchCommonParams.style_id"
              :options="TaskStyleGroupOptions"
              placeholder="StyleID"
            />
          </a-form-item>

          <a-form-item  label="任务子类型"  name="sub_type">
            <a-select
              v-model:value="batchCommonParams.sub_type"
              :options="SubTypeOptions"
              placeholder="SubType"
            />
          </a-form-item>
          <a-form-item label="涂抹" name="spreadable">
            <a-select
                style="width: 80px;"
                v-model:value="batchCommonParams.spreadable"
                :options="spreadableOptions"
                placeholder="spreadable"
              />
          </a-form-item>
          <a-form-item label="默认提示词" name="prompt">
            <a-textarea :rows="3" placeholder="prompt" v-model:value="batchCommonParams.prompt" />
          </a-form-item>
          
          <a-form-item label="性别" name="typeid">
            <a-select
                style="width: 80px;"
                v-model:value="batchCommonParams.typeid"
                :options="[
                  {
                    value: '',
                    label: '所有'
                  },
                  {
                    value: 'female',
                    label: '女性'
                  },
                  {
                    value: 'male',
                    label: '男性'
                  },
                ]"
                placeholder="typeid"
              />
          </a-form-item>
          <template v-if="batchCommonParams.tool_id == 'clothes'">
            <a-form-item label="分类名称" name="category_name">
              <a-select
                  style="width: 100px;"
                  v-model:value="batchCommonParams.category_name"
                  :options="categoryOptions"
                  placeholder="category_name"
                />
              <p>*仅换装需要填写</p>
            </a-form-item>
          </template>
        
          <a-form-item label="Position" name="position" v-if="false">
          <a-input placeholder="position" v-model:value="batchCommonParams.position" />
        </a-form-item>
        <a-form-item label="扩展参数" name="value" v-if="false">
          <a-textarea placeholder="extend params" v-model:value="batchCommonParams.value" />
        </a-form-item>
        <a-form-item label="模板动画位置" name="blind_position" v-if="false">
          <a-select
              v-model:value="batchCommonParams.blind_position"
              :options="[{
                label: '编辑器',
                value: 'editor',
              },{
                label: '首页',
                value: 'home',
              },{
                label: '所有页面',
                value: 'all',
              }]"
              placeholder="动画展示位置"
            />
        </a-form-item>
        <a-form-item label="推荐标签" name="label" v-if="false">
            <Inputi18nInline  v-model:valid="batchCommonParams.label_i18n_valid" v-model:value="batchCommonParams.label" />
        </a-form-item>
        </div>
        
        <!-- 文件夹上传 -->
        <div style="margin: 10px;width: 800px;">
          <p class="form-section-title">文件夹上传</p>
          <a-form-item label="上传文件夹">
            <a-button type="primary" @click="handleFolderUpload">上传文件夹</a-button>
            <input 
              type="file" 
              ref="folderInput"
              style="display: none" 
              webkitdirectory 
              directory 
              @change="handleFolderChange"
            />
          </a-form-item>
          <!-- 批量模板配置 -->
          <p class="form-section-title">批量模板配置</p>
          <a-form-item label="">
            <a-button type="primary" @click="handleAddTemplate">+添加</a-button>
            <div style="margin-top: 5px; font-size: 12px; color: #999;">点击添加一个以封面为核心的模板配置</div>
          </a-form-item>
          <div v-if="batchTemplateData.length > 0">
            <div style="margin: 10px 0; font-weight: bold;">共 {{ batchTemplateData.length }} 个模板</div>
            <div style="display: grid; grid-template-columns: repeat(10, 1fr); gap: 15px; margin: 10px 0;">
              <div v-for="(template, index) in batchTemplateData" :key="index" style="min-width: 200px;padding: 10px; border: 1px solid #f0f0f0; border-radius: 4px; display: flex; flex-direction: column; align-items: center;">
                <div style="text-align: center; font-size: 12px; margin-bottom: 5px;">模板 {{ index + 1 }}</div>
                <a-form-item label="" style="margin-bottom: 10px;">
                  <Upload v-model:imageUrl="template.image_url" />
                  <div style="margin-top: 5px;">
                    <a-button type="text" danger size="small" @click="handleDeleteTemplate(index)">删除</a-button>
                  </div>
                </a-form-item>
                <a-form-item label="" style="margin-bottom: 5px; width: 100%;">
                  <div>后台名称</div>
                  <a-input size="small" placeholder="后台名称" v-model:value="template.title" />
                </a-form-item>
                <a-form-item label="" style="margin-bottom: 5px; width: 100%;">
                    <div>标题(国际化)</div>
                    <Inputi18nInline  v-model:valid="template.name_i18n_valid" v-model:value="template.name" size="small" />
                </a-form-item>
                <a-form-item label="" style="margin-bottom: 0; width: 100%;">
                  <div>排序</div>
                  <a-input  type="number" size="small" placeholder="排序" v-model:value="template.sorted" />
                  <div style="font-size: 10px; margin-top: 2px; color: #999;">*数字越大越靠前</div>
                </a-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a-alert v-if="batchTemplateData.length == 0"  type="warning" message="请先上传文件夹" banner />
      </a-form>
  </a-modal>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import Upload from '@/components/Upload.vue'
import UploadVideo from '@/components/UploadVideo.vue'
import ConvertVideo from '@/components/ConvertVideo.vue'
// import Inputi18n from '@/components/Inputi18n.vue'
import Inputi18nInline from '@/components/Inputi18nInline.vue'



import { Modal, message } from 'ant-design-vue';

import {  TaskStyleGroupOptions, SubTypeOptions,ToolIDOptions, ToolNames, StyleFlowNames, StyleNames, SubTypeNames,
  Operators,
   NationCodes} from '@/utils/macro'
import {generateRandomString} from '@/utils/string'
const DefaultRecord = {
  "id": 0,
  "title": "",
  "tool_id": "",
  "style_id": "",
  "typeid": "",
  "category_id": "",
  "category_name": "",
  "version": "",
  "region_code": "CN",
  "prompt": "",
  "redirect_url": "",
  "image_url": "",
  "video_url": "",
  "cover_blind": "",
  "blind_position": "all",
  "ori_url": "",
  "name": "",
  "name_i18n_valid": false,
  "tab_name_i18n_valid": false,
  "label_i18n_valid": false,
  "label":"",
  "value": "",
  "spreadable": "0",
  "brush_size": 20,
  "brush_max_size": 50,
  "brush_min_size": 1,
  "brush_type": "Normal",
  "show_scores": false,
  "scores": 0,
  "img2video_template_id": null,
  "need_audio": false,
  "mask_url": "",
  "sorted":"999",
  "tab_id":"",
  "tab_name":"",
  "tab_sorted":"100",
  "sub_type": "",
  "cover_media_type": "image",
}



export default defineComponent({
  components: {
    Upload,
    // Inputi18n,
    Inputi18nInline,
    SearchOutlined,
    UploadVideo,
    ConvertVideo,
  },
  data() {
    return {
      SubTypeOptions: SubTypeOptions,
      ToolIDOptions: ToolIDOptions,
      ToolNames: ToolNames,
      styleNames: StyleNames,
      NationCodes: NationCodes,
      subTypeNames: SubTypeNames,
      TaskStyleGroupOptions: TaskStyleGroupOptions,
      StyleFlowNames: StyleFlowNames,
      Operators: Operators,
      loading: false,
      openDia: false,
      dataSource: [],
      action_image_index: 0,
      formRecord: {
        ...DefaultRecord
      },
      activeCollapseKey: ['1'],
      rules: {
        title: [
          { required: true, message: 'required', trigger: 'change' }
        ],
        tool_id: [
          { required: true, message: 'required', trigger: 'change' }
        ],
        style_id: [
          { required: true, message: 'required', trigger: 'change' }
        ],
        name: [
          { required: true, message: 'required', trigger: 'change' }
        ],
        spreadable: [
          { required: true, message: 'required', trigger: 'change' }
        ]
      },
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      spreadableOptions: [
        {
          label: "无需",
          value: "0"
        },
        {
          label: "必须",
          value: "1"
        },
        {
          label: "可选",
          value: "2"
        }
      ],
      categoryOptions: [
        {
          label: "全身",
          value: "whole"
        },
        {
          label: "上装",
          value: "tops"
        },
        {
          label: "下装",
          value: "bottoms"
        }
      ],
      status: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '上线',
          value: '1'
        },
        {
          label: '下线',
          value: '0'
        },
        {
          label: '预览',
          value: '2'
        }
      ],
      optionTabs: [],
      formSearch: {
        title: '',
        status: '',
        style_id: '',
        template_id: '',
        sub_type: '',
        region_code: '',
        tab_id: '',
        gender: null
      }
    };
  },
  mounted(){
    if (this.$route.query.template_id) {
      this.formSearch.template_id = this.$route.query.template_id
    }
    this.handleTableChange()
  },
  watch: {
    'formRecord.style_id': {
      handler(newVal, oldVal) {
        if (this.formRecord.id) {
          return
        }
        if (newVal === 'pixverse-img2video') {
          if (this.formRecord.need_audio) {
            this.formRecord.scores = 50
          } else {
            this.formRecord.scores = 40
          }
        } else if (oldVal === 'pixverse-img2video' && newVal !== 'pixverse-img2video') {
          this.formRecord.scores = 0
        }
      }
    },
    'formRecord.need_audio': {
      handler(newVal, oldVal) {
        if (this.formRecord.id) {
          return
        }
        if (this.formRecord.style_id === 'pixverse-img2video') {
          if (newVal) {
            this.formRecord.scores = 50
          } else {
            this.formRecord.scores = 40
          }
        }
      }
    },
    'formRecord.position': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formRecord.value = JSON.stringify({
            position: newVal
          })
        }
      }
    },
    'formRecord.image_url': {
      handler(newVal, oldVal) {
        // 如果是视频tab，并且video_url没有值，如果image_url的后缀是.webp，则把后缀换成.mp4赋值给video_url
        if (!this.formRecord.video_url &&
            newVal &&
            newVal.endsWith('.webp')) {
          this.formRecord.video_url = newVal.replace(/\.webp$/, '.mp4')
        }
      }
    }
  },
  methods: {
    async handleConfirm(){
      if (!(this.formRecord.title)) {
        message.error('请填写后台标题')
        return
      }
      
      if (!this.formRecord.tool_id) {
        message.error('请填写工具')
        return
      }
      if (!this.formRecord.tab_id) {
         message.error('请选择归属 Tab，如果没展示请点击「加载Tab」')
        return
      }
      if (!(this.formRecord.name_i18n_valid)) {
        message.error('表单展示文案不支持国际化，请补充国际化文案')
        return
      }
      if (!this.formRecord.image_url) {
        message.error('请上传封面(效果图)')
        return
      }

      // pixverse-img2video 类型校验
      if (this.formRecord.style_id === 'pixverse-img2video') {
        const hasTemplateId = this.formRecord.img2video_template_id !== null && this.formRecord.img2video_template_id !== 0
        const hasPrompt = this.formRecord.prompt && this.formRecord.prompt.trim() !== ''
        
        if (!hasTemplateId && !hasPrompt) {
          message.error('模板ID和默认提示词不能同时为空')
          return
        }
      }
      
      // 如果推荐标签为空，删除推荐标签的 i18n 文案
      if (!this.formRecord.label_i18n_valid) {
        this.formRecord.label = ""
      }
      if (this.formRecord.position) {
        this.formRecord.value = JSON.stringify({
          position: this.formRecord.position
        })
      }
      const reqData = {
        ...this.formRecord,
        image_url: this.formRecord.image_url.replace("http://statica.xuantu.pro/", ""),
        ori_url: this.formRecord.ori_url.replace("http://statica.xuantu.pro/", ""),
        sorted: +this.formRecord.sorted,
        spreadable: +this.formRecord.spreadable,
        tab_sorted: +this.formRecord.tab_sorted,
      }
      if (this.formRecord.spreadable !== '0') {
        reqData.brush_size = +this.formRecord.brush_size
        reqData.brush_max_size = +this.formRecord.brush_max_size
        reqData.brush_min_size = +this.formRecord.brush_min_size
        reqData.brush_type = this.formRecord.brush_type
      }
      reqData.show_scores = this.formRecord.show_scores
      reqData.scores = +this.formRecord.scores
      if (this.formRecord.style_id === 'pixverse-img2video') {
        if (this.formRecord.img2video_template_id) {
          reqData.img2video_template_id = this.formRecord.img2video_template_id
        } else {
          reqData.img2video_template_id = 0
        }
        reqData.need_audio = this.formRecord.need_audio
      }
      reqData.mask_url = this.formRecord.mask_url
      if (this.formRecord.id) {
        const rsp = await request.put(`/api/creation/options/${this.formRecord.id}`, reqData)
      } else {
        const rsp = await request.post('/api/creation/options', reqData)
      }
     
      this.openDia = !this.openDia
      this.loading = false
      this.handleTableChange({
        ...this.pagination
      })
    },
    // 批量创建相关方法
    handleBatchCreate() {
      this.$router.push('/home/creation/batch-create')
    },

    handleCreate(){
      this.openDia = true
      let data = {
        ...DefaultRecord
      }
      data.region_code = this.formSearch.region_code
      if (data.region_code == "") {
        data.region_code = "CN"
      }
      const id = generateRandomString(10)
      data.name = "template.title." + id
      data.label = "template.label." + id
      // data.tab_name = "creation_tab_" + generateRandomString(10)
      this.formRecord = data
    },
    handleCopy(record) {
      const _record = {
        ...record,
        is_copy: true,
        id: 0,
      }
      this.handleUpdate(_record)
      const id = generateRandomString(10)
      this.formRecord.title = ''
      this.formRecord.name = "template.title.cp_" + id
      this.formRecord.label = "template.label.cp_" + id
      this.formRecord.name_i18n_valid = false
      this.formRecord.label_i18n_valid = false
    },
    handleUpdate(record){
      this.openDia = true
      // console.log(record)
      let data = {
        ...record,
        sorted: +record.sorted,
        tab_sorted: +record.tab_sorted,
      }
      if (!data.name){
        data.name = "option.title." + generateRandomString(10)
      }
      if (!data.label){
        data.label = "option.label." + generateRandomString(10)
      }
      this.formRecord = data
      
      this.getOptionTabs()
    },
    async handleDelete(record){
      this.loading = true
      await request.delete(`/api/creation/options/${record.id}`, { })
      this.loading = false
      this.handleTableChange({
        ...this.pagination
      })
    },
    async handleOnline(record){
      this.loading = true
      await request.put(`/api/creation/options/${record.id}`, {
        is_delete: 0,
      })
      this.loading = false
      this.handleTableChange({
        ...this.pagination
      })
    },
    async handleModifySort(record){
      this.loading = true
      await request.put(`/api/creation/options/${record.id}/sort`, {
        sorted: +record.sorted,
      })
      this.loading = false
      this.handleTableChange({
        ...this.pagination
      })
    },
    async handleModifyStatus(record, status){
      this.loading = true
      await request.put(`/api/creation/options/${record.id}/status`, {
        status: +status,
      })
      this.loading = false
      this.handleTableChange({
        ...this.pagination
      })
    },
    resetForm() {
      this.formRecord = {
       ...DefaultRecord
      }
      this.$refs.formRef.resetFields();
    },
    async searchOptionTabs(){
      window.open(`/home/creation/tabs?tool_id=${this.formRecord.tool_id}&sub_type=${this.formRecord.sub_type}&region_code=${this.formRecord.region_code}`, '_blank')
    },
    async getOptionTabs(){
      if (this.formRecord.tool_id == "" || this.formRecord.region_code == "" ) {
        message.error('请选择工具类型、地区')
        return
      }
      let resp = await request.get('/api/creation/option_tabs', {
        tool_id: this.formRecord.tool_id,
        limit: 999,
      })
      this.optionTabs = []
      if (resp.data.list) {
        for(let v of resp.data.list) {
          this.optionTabs.push({
            label: v.tab_name,
            value: v.id,
          })
        }
      }
      if (this.optionTabs.length > 0 && this.formRecord.tab_id == "") {
        this.formRecord.tab_id = this.optionTabs[0].value
      }
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/creation/options', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch
      })
      this.loading = false
      if (rsp.data.list == null) {
        this.noticeMessage = '暂无数据'
        this.dataSource = []
        return
      }
      for (let i = 0; i < rsp.data.list.length; i++) {
        rsp.data.list[i].created_at = new Date(rsp.data.list[i].created_at)
        rsp.data.list[i].updated_at = new Date(rsp.data.list[i].updated_at)
        if (rsp.data.list[i].name != "") {
          rsp.data.list[i].name_i18n_valid = true
        }
        if (rsp.data.list[i].label != "") {
          rsp.data.list[i].label_i18n_valid = true
        }
        if (rsp.data.list[i].tab_name != "") {
          rsp.data.list[i].tab_name_i18n_valid = true
        }
        rsp.data.list[i].spreadable =  `${rsp.data.list[i].spreadable}`
        rsp.data.list[i].brush_size = rsp.data.list[i].extra?.brush_size || 20
        rsp.data.list[i].brush_max_size = rsp.data.list[i].extra?.brush_max_size || 50
        rsp.data.list[i].brush_min_size = rsp.data.list[i].extra?.brush_min_size || 1
        rsp.data.list[i].brush_type = rsp.data.list[i].extra?.brush_type || "Normal"
        rsp.data.list[i].show_scores = rsp.data.list[i].extra?.show_scores || false
        rsp.data.list[i].scores = rsp.data.list[i].extra?.scores || 0
        rsp.data.list[i].need_audio = rsp.data.list[i].extra?.need_audio || false
        rsp.data.list[i].img2video_template_id = rsp.data.list[i].extra?.img2video_template_id || null
        rsp.data.list[i].mask_url = rsp.data.list[i].extra?.mask_url || ""
      }
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
    return {
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '任务类型',
          dataIndex: 'style_id',
          key: 'style_id',
          slots: { customRender: 'style_name' },
        },
        {
          title: '工具',
          dataIndex: 'tool_id',
          key: 'tool_id',
          slots: { customRender: 'tool_id' },
        },
        {
          title: '名称',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: '封面图',
          dataIndex: 'image_url',
          key: 'image_url',
          slots: { customRender: 'image_url' },
        },
        {
          title: '地区',
          dataIndex: 'region_code',
          key: 'region_code',
          slots: { customRender: 'region_code' },
        },
        {
          title: 'Tab',
          dataIndex: 'tab_name',
          key: 'tab_name',
          slots: { customRender: 'tab_name' },
        },
        {
          title: '排序',
          slots: { customRender: 'sort' },
        },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   key: 'status',
        //   slots: { customRender: 'status' },
        // },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          slots: { customRender: 'created_at' },
        },
        {
          title: '操作人 ID',
          dataIndex: 'operator_id',
          key: 'operator_id',
          slots: { customRender: 'opeartor' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

</style>
